import { path as parentPath } from "../init";

export const path = `${parentPath}/selections`;

export const apiUrls = {
  list: "/api/specials/selections",
  prompt: "/api/specials/selections/prompt",
  positions: "/api/specials/selections/positions",
  info: "/api/specials/selections/selection_{selectionId}",
  start: "/api/specials/selections/selection_{selectionId}/start",
};

export const infoLink = (source) => {
  return `${path}/selection_${source._id}`;
};

export const formLink = (schedule) => {
  return `${infoLink(schedule)}/form`;
};
